document.addEventListener('turboujs:load', (_event) => {
  document.querySelectorAll('.desktop-calendar-header__form form select').forEach((element, i) => {
    element.addEventListener('change', selectChanged)
  })
})

function selectChanged(event) {
  let form = this.closest('form')
  console.log(event.target.value)
  form.submit()
}
